import { Injectable, HostBinding } from '@angular/core';
import { BG_COLOUR, PANEL_COLOUR, CONTRAST_COLOUR, BG_COLOUR_1, BG_COLOUR_2, BG_COLOUR_3, BG_COLOUR_4, BG_DISTANCE_1, BG_DISTANCE_2, BG_DISTANCE_3, BG_DISTANCE_4, BS_BODY_BG  } from 'src/app/_core/constants/style.constants';

export class DynamicColourSettings {
    min: string;
    max: string;
}

export class DynamicPositionSettings {
    min: number;
    max: number;
    unit: string;
}

@Injectable({
    providedIn: 'root'
})
export class DynamicStyleService {

    // Settings
    private readonly _settings = [
        {
            key: BS_BODY_BG,
            setting: { min: "#eeeeee", max: "#cccccc", steps: 4 }
        },
        {
            key: BG_COLOUR,
            setting: { min: "#ffffff", max: "#404040" }
        },
        {
            key: PANEL_COLOUR,
            setting: { min: "#F3F3F3", max: "#212529", steps: 10  }
        },
        {
            key: CONTRAST_COLOUR,
            setting: { min: "#404040", max: "#ffffff", steps: 2 }
        },
        {
            key: BG_COLOUR_1,
            setting: { min: "#f4fefe", max: "#ffffff" }
        },
        {
            key: BG_COLOUR_2,
            setting: { min: "#dcffff", max: "#bbbbbb" }
        },
        {
            key: BG_COLOUR_3,
            setting: { min: "#a8d5f3", max: "#0e2433" }
        },
        {
            key: BG_COLOUR_4,
            setting: { min: "#91bfe1", max: "#262627" }
        },
        {
            key: BG_DISTANCE_1,
            setting: { min: 30, max: 28, unit: "vh" }
        },
        {
            key: BG_DISTANCE_2,
            setting: { min: 45, max: 38, unit: "vh" }
        },
        {
            key: BG_DISTANCE_3,
            setting: { min: 55, max: 42, unit: "vh" }
        },
        {
            key: BG_DISTANCE_4,
            setting: { min: 66, max: 70, unit: "vh" }
        },
    ];

    // radial-gradient(circle, #f4fefe 30vh, #dcffff 45vh, #a8d5f3 65vh, #91bfe1 80vh);

    constructor() {
    }

    // Public methods
    refresh(key: string, percentage: number, isColour: boolean = false) {
        const setting = this._settings.find(x => x.key == key).setting;

        if (isColour) {
            return this._interpolateColours(setting.min.toString(), setting.max.toString(), percentage, setting.steps ?? 100);
        } else {
            return this._interpolateValues(+setting.min, +setting.max, percentage, setting.steps ?? 100, setting.unit);
        }
    }

    // Private methods

    private _interpolateColours(hexColourStart: string, hexColourEnd: string, percentage: number, steps: number): string {
        const rgbColourStart = this._hexToRgb(hexColourStart);
        const rgbColourEnd = this._hexToRgb(hexColourEnd);

        const new_r = this._interpolateValues(rgbColourStart.r, rgbColourEnd.r, percentage, steps);
        const new_g = this._interpolateValues(rgbColourStart.g, rgbColourEnd.g, percentage, steps);
        const new_b = this._interpolateValues(rgbColourStart.b, rgbColourEnd.b, percentage, steps);

        const result = this._rgbToHex(new_r, new_g, new_b);

        return result;
    }

    private _hexToRgb(hex: string) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    private _componentToHex(c) {
        const hex = c.toString(16);
        return hex.length == 1 ? `0${  hex}` : hex;
      }
      
      private _rgbToHex(r, g, b) {
        return `#${  this._componentToHex(+r)  }${this._componentToHex(+g)  }${this._componentToHex(+b)}`;
      }

    private _interpolateValues(start: number, end: number, percentage: number, steps: number, unit: string = "") {

        steps = steps - 1;
        percentage = Math.round(percentage * steps)/steps

        let resultNumber = start + (end - start) * percentage;
        resultNumber = Math.round(resultNumber);

        let result = resultNumber.toString()

        if (unit) {
            result = result + unit;
        }

        return result;
    }
}